import Badge from "@mui/material/Badge";

export default Badge;
export type { BadgeProps } from "@mui/material/Badge";
